import { AxiosConfig } from "../AxiosConfig/AxiosConfig";
export const submitFeedback = (comment) => new Promise(async (resolve, reject) => {
    try {
        const content = JSON.stringify({ comment: comment });
        const response = await AxiosConfig.instance.post("/feedback", content);
        return resolve(response.data);
    }
    catch (error) {
        console.error(error);
        reject("Can't submit feedback");
    }
});
